export enum StatusCadastroUsuarioEnum {
    PENDENTE = 'PENDENTE',
    // AGUARDANDO_ATIVACAO = 'AGUARDANDO_ATIVACAO',
    ATIVO = 'ATIVO',
    INATIVO = 'INATIVO'
}
